// API wrappers for the omnichannel messaging INBOX (Phase 1). Backend mounted at
// /api/messaging. Thin pass-throughs to the shared fetch helpers in ../index.
import { post, get } from "../index";

const BASE = "/api/messaging";

function qs(params = {}) {
  const p = Object.entries(params).filter(([, v]) => v != null && v !== "");
  return p.length ? "?" + p.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&") : "";
}

// Conversation thread list (previews), optionally filtered by brand/channel/status.
export const getConversations = (params) => get(`${BASE}/conversations${qs(params)}`);

// One conversation with its full message history.
export const getConversation = (id) => get(`${BASE}/conversations/${id}`);

// Operator reply (sends on the conversation's channel + appends).
export const replyConversation = (id, text) => post(`${BASE}/conversations/${id}/reply`, { text }, false);

// Clear the unread flag.
export const markConversationRead = (id) => post(`${BASE}/conversations/${id}/read`, {}, false);

// Queue an AI brand-voice draft for a conversation (worker fills aiDraft).
export const aiDraftConversation = (id) => post(`${BASE}/conversations/${id}/ai-draft`, {}, false);

// Per-brand AI reply config (enabled + autoReply).
export const getBrandAiConfig = (brandSettingsId) => get(`${BASE}/ai-config?brandSettingsId=${encodeURIComponent(brandSettingsId)}`);
export const setBrandAiConfig = (data) => post(`${BASE}/ai-config`, data, false);

// Contacts (Phase 3).
export const getContacts = (params) => get(`${BASE}/contacts${qs(params)}`);
export const importContacts = (data) => post(`${BASE}/contacts/import`, data, false);
export const updateContact = (id, data) => post(`${BASE}/contacts/${id}`, data, false); // PATCH via post helper? see note
export const deleteContact = (id) => post(`${BASE}/contacts/${id}/delete`, {}, false);

// Campaigns (Phase 4).
export const getCampaigns = (params) => get(`${BASE}/campaigns${qs(params)}`);
export const sendCampaign = (data) => post(`${BASE}/campaigns/send`, data, false);
